var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import CustomIllustration from "@frameworks/shared-library/assets/images/features/Markets/MutualFunds/validate-client.svg";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/MandateType/MandateType.scss";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import { EValidateOptions, validateOptions, validationOptionErrors, } from "@frameworks/salesjourney/components/Features/PlaceOrder/AccessControl/constants";
import { emailRegex } from "@frameworks/salesjourney/utils/regex";
import InputField from "@frameworks/web/components/generic/inputField";
import { acceptIntegerOnly, isControlKey, } from "@frameworks/salesjourney/utils/validation";
import GenericDateSelectorModal from "@frameworks/shared-library/components/GenericDateSelector/GenericDateSelectorModal/GenericDateSelectorModal";
var inceptionDate = new Date(new Date().setFullYear(new Date().getFullYear() - 99));
function ClientAccessValidationForm(_a) {
    // *******************************************
    // *          USE STATE           *
    // *******************************************
    var selectedOption = _a.selectedOption, mobileNo = _a.mobileNo, selectedDate = _a.selectedDate, email = _a.email, onSelectedOptionChange = _a.onSelectedOptionChange, onMobileNoChange = _a.onMobileNoChange, onSelectedDateChange = _a.onSelectedDateChange, onEmailChange = _a.onEmailChange, formErrors = _a.formErrors, setFormErrors = _a.setFormErrors, clientDetails = _a.clientDetails;
    var clientValidationRef = useRef();
    var clientValidationFormRef = useRef();
    var _b = __read(useState(false), 2), openCalendar = _b[0], setOpenCalendar = _b[1];
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    var generateValidationTypeInputFields = function () {
        switch (selectedOption) {
            case EValidateOptions.MOBILE:
                return (React.createElement("div", null,
                    React.createElement("div", { className: "verify-client ".concat((formErrors === null || formErrors === void 0 ? void 0 : formErrors.mobile) && "error") },
                        React.createElement("div", { className: "country-code" },
                            React.createElement("p", { className: "Roboto_14_400 mb-0 txt-han-blue" }, "91"),
                            React.createElement("span", { className: "edel-icon-arrow-down icon" })),
                        React.createElement(InputField, { inputMode: "tel", type: "number", maxLength: 10, placeholder: "Enter Mobile Number", value: mobileNo, onKeyDown: function (e) {
                                if (!acceptIntegerOnly(e.key) && !isControlKey(e.key)) {
                                    e.preventDefault();
                                }
                            }, onWheel: function (e) {
                                return e.currentTarget.blur();
                            }, placeholderClassName: "", onChangeEvent: handleOnChangeMobileValue, autoComplete: "disabled-autofill" })),
                    formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.mobile) && (React.createElement("p", { className: "DMSanN_13_400 txt-tomato mgt-5 mgl-5" }, formErrors === null || formErrors === void 0 ? void 0 : formErrors.mobile))));
            case EValidateOptions.DATE_OF_BIRTH:
                return (React.createElement("div", { className: "client-validation-dob-input mt-3" },
                    React.createElement("div", { className: "d-flex flex-row date-picker-block" },
                        React.createElement("p", { className: "calendar-prefix" },
                            React.createElement("i", { className: "edel-icon-calendar-rounded", onClick: function () { return setOpenCalendar(!openCalendar); } })),
                        React.createElement(InputField, { placeholder: "Enter Date of birth", value: selectedDate ? moment(selectedDate).format("DD-MMM-YYYY") : "", readOnly: true, placeholderClassName: "", onClick: function () { return setOpenCalendar(!openCalendar); }, className: "date-of-birth-input-field" }),
                        openCalendar && (React.createElement(GenericDateSelectorModal, { title: "Date of Birth", onApplyClick: function (date) {
                                if (!Array.isArray(date)) {
                                    onSelectedDateChange(date);
                                }
                                setOpenCalendar(false);
                            }, selectedDate: selectedDate, onCancelClick: function () { return setOpenCalendar(false); }, inceptionDate: inceptionDate, parentClassName: "client-dob-calendar" }))),
                    formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.dob) && (React.createElement("p", { className: "DMSanN_13_400 txt-tomato mgt-5 mgl-5" }, "Invalid date of birth. Please enter a valid date."))));
            case EValidateOptions.EMAIL:
                return (React.createElement("div", { className: "mt-3 verify-client flex-column ".concat((formErrors === null || formErrors === void 0 ? void 0 : formErrors.email) && "error") },
                    React.createElement(InputField, { inputMode: "text", type: "string", placeholder: "Enter Email ID", className: "input-email", value: email, placeholderClassName: "", onChangeEvent: handleOnChangeEmailValue, autoComplete: "disabled-autofill" }),
                    formErrors && (formErrors === null || formErrors === void 0 ? void 0 : formErrors.email) && (React.createElement("p", { className: "DMSanN_13_400 txt-tomato mgt-5 mgl-5" }, "Invalid email address. Please enter a valid email."))));
            default:
                return null;
        }
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleOnChangeMobileValue = function (e) {
        var value = e.target.value;
        if (value.length > 0 && value.length < 10) {
            setFormErrors(__assign(__assign({}, formErrors), { mobile: "Please enter a valid mobile number" }));
        }
        else {
            setFormErrors(__assign(__assign({}, formErrors), { mobile: "" }));
        }
        onMobileNoChange(value);
    };
    var handleOnChangeEmailValue = function (e) {
        var value = e.target.value;
        if (!emailRegex.test(value) && value.length > 0) {
            setFormErrors(__assign(__assign({}, formErrors), { email: validationOptionErrors.email }));
        }
        else {
            setFormErrors(__assign(__assign({}, formErrors), { email: "" }));
        }
        onEmailChange(e.target.value);
    };
    var handleOnValidationOptionChange = function (e) {
        onMobileNoChange("");
        onEmailChange("");
        onSelectedOptionChange(e.target.value);
        setFormErrors({
            mobile: "",
            email: "",
            dob: "",
        });
    };
    var handleIllustrationDisplay = function () {
        var body = clientValidationRef === null || clientValidationRef === void 0 ? void 0 : clientValidationRef.current;
        var form = clientValidationFormRef === null || clientValidationFormRef === void 0 ? void 0 : clientValidationFormRef.current;
        var illustration = document.getElementById("validate-client-sidebar-body-illustration");
        if (body && form) {
            var bodyHeight = body.offsetHeight;
            var formHeight = form.offsetHeight;
            if (illustration) {
                illustration.style.display =
                    bodyHeight - formHeight < 220 ? "none" : "block"; // 214 is illustration's height
            }
        }
    };
    // *******************************************
    // *           UseEffects                    *
    // *******************************************
    useEffect(function () {
        window.addEventListener("resize", handleIllustrationDisplay);
        return function () {
            return window.removeEventListener("resize", handleIllustrationDisplay);
        };
    }, []);
    // *******************************************
    // *            Rendering                    *
    // *******************************************
    return (React.createElement("div", { className: "validate-client-sidebar-body add-client overflow-scroll", ref: clientValidationRef },
        React.createElement("div", null,
            React.createElement("div", { className: "px-15 pt-20", ref: clientValidationFormRef },
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { className: "DMSanN_14_400 txt_blackOne1 validate-client-input-label" }, "PAN"),
                    React.createElement(InputField, { disabled: true, inputMode: "text", type: "string", max: 999, defaultValue: clientDetails.pan, value: clientDetails.pan, placeholderClassName: "PAN" })),
                React.createElement("div", { className: "form-group" },
                    React.createElement("label", { className: "DMSanN_14_400 txt_blackOne1" }, "Client Name"),
                    React.createElement(InputField, { disabled: true, inputMode: "text", type: "string", max: 999, defaultValue: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientName, value: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.clientName, placeholderClassName: "Client Name" })),
                React.createElement("div", { className: "primary-mandate-radio-btns-container d-flex" }, (validateOptions === null || validateOptions === void 0 ? void 0 : validateOptions.length) > 0 &&
                    validateOptions.map(function (item, count) { return (React.createElement(RadioButton, { name: "validateBy", list: item, onChange: handleOnValidationOptionChange, selected: selectedOption, key: count, className: "common-radio-button selected-desk-tab" })); })),
                React.createElement("div", { className: "selected-form-group" }, generateValidationTypeInputFields())),
            React.createElement("img", { id: "validate-client-sidebar-body-illustration", src: CustomIllustration, className: "position-absolute validate-client-illustration", width: 150, height: 152 }))));
}
export default ClientAccessValidationForm;
